import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Logo from "../../../assets/images/Logo.png";
import moment from "moment";
import localization from "moment/locale/vi";
var theMoment = moment().local("vi", localization);
export default function Footer() {
  return (
    <Grid
      container
      direction="row"
      style={{
        color: "white",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-end",
      }}
    >
      <Grid item>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={Logo}
            alt="bun-bo-o-nhu-logo"
            style={{ width: "80%", height: "80%" }}
          ></img>
          <Typography
            varian="body1"
            gutterBottom
            style={{
              fontStyle: "italic",
              color: "red",
              whiteSpace: "nowrap",
            }}
          >
            Thơm Ngon Đậm Vị!
          </Typography>
        </div>
      </Grid>
      <Grid item direction="row">
        <Typography
          style={{
            paddingLeft: "1.25rem",
            paddingRight: "1rem",
            paddingBottom: "0.35rem",
          }}
        >
          {theMoment.format("Do MMM YY")} / {theMoment.format("LT")}
        </Typography>
      </Grid>
    </Grid>
  );
}
